import { render, staticRenderFns } from "./OrgSchoolReport.vue?vue&type=template&id=60c6e238&scoped=true&"
import script from "./OrgSchoolReport.vue?vue&type=script&lang=js&"
export * from "./OrgSchoolReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6e238",
  null
  
)

export default component.exports